'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _blueimpGallery = require('blueimp-gallery');

var _blueimpGallery2 = _interopRequireDefault(_blueimpGallery);

require('blueimp-gallery/css/blueimp-gallery.min.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imgViewerContext = '@@imgViewerContext';

var createContainer = function createContainer() {
  var div = document.createElement('div');
  div.id = 'blueimp-gallery';
  div.classList.add('blueimp-gallery');

  div.innerHTML = '\n    <div class="slides"></div>\n    <h3 class="title"></h3>\n    <a class="prev">\u2039</a>\n    <a class="next">\u203A</a>\n    <a class="close">\xD7</a>\n    <a class="play-pause"></a>\n    <ol class="indicator"></ol>\n  ';

  document.body.appendChild(div);
};

var viewer = function viewer() {
  var container = document.querySelector('#blueimp-gallery');
  if (!container) {
    createContainer();
  }

  _blueimpGallery2.default.apply(undefined, arguments);
};

exports.default = function (Vue) {

  Vue.prototype.$viewer = viewer;

  Vue.directive('img-viewer', {
    bind: function bind(el) {
      var show = function show() {
        var url = el[imgViewerContext].url;

        if (!url) {
          return;
        }

        viewer([url]);
      };
      el[imgViewerContext] = { show: show };
    },
    inserted: function inserted(el, _ref) {
      var value = _ref.value;

      var context = el[imgViewerContext];
      context.url = value;
      el.addEventListener('click', context.show);
    },
    update: function update(el, _ref2) {
      var value = _ref2.value;

      el[imgViewerContext].url = value;
    },
    unbind: function unbind(el) {
      var show = el[imgViewerContext].show;

      el.removeEventListener('click', show);
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/directives/img-viewer/index.js
// module id = 306
// module chunks = 0